export default __webpack_public_path__ + "static/media/assign2.72b47ced.svg";